import React from "react";
import { z } from "zod";

export const LOCAL_STORAGE_IS_PARENT_KEY = "AvelaIsParent";

/**
 * Hook to store `isParent` value in localStorage to persist the value between login and auth callback.
 * This will allow us to redirect user to the right login page after auth error.
 */
export const useIsParentStorage = () => {
  const setValue = React.useCallback((isParent: boolean) => {
    window.localStorage.setItem(
      LOCAL_STORAGE_IS_PARENT_KEY,
      JSON.stringify(isParent)
    );
  }, []);

  const getValue = React.useCallback((): boolean | null => {
    const raw = window.localStorage.getItem(LOCAL_STORAGE_IS_PARENT_KEY);
    if (raw === null) {
      return null;
    }

    const isParent = z.boolean().safeParse(JSON.parse(raw));
    if (isParent.success) {
      return isParent.data;
    }

    return null;
  }, []);

  const clearValue = React.useCallback(() => {
    window.localStorage.removeItem(LOCAL_STORAGE_IS_PARENT_KEY);
  }, []);

  return { setValue, getValue, clearValue };
};
